export default __webpack_public_path__ + "static/media/yawo-logo.3fd5ebcb.svg";